(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["knife-landing"] && !Shopify.designMode) return;
  try {
    
  // Section-owned listeners survive editor moves without duplicating cart adds.
  class KnifeLandingActions extends HTMLElement {
    connectedCallback() {
      this.disconnectedCallback();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.fixLinks();
      this.watchMain();
      this.addEventListener('click', (event) => this.activate(event), { signal });
      document.addEventListener('cart:update', (event) => {
        if (!this.pending || event.detail?.data?.source !== 'product-form-component' ||
            String(event.detail.sourceId) !== this.pending.variantId) return;
        this.complete();
      }, { signal });
    }

    purchase() {
      // Restrict to this page product's shopping area, excluding quick-add,
      // recommendations and accessory forms even if they occur first in DOM.
      const main = this.closest('main');
      if (!main || !this.dataset.productId) return null;
      for (const target of main.querySelectorAll('[id^="ProductInformation-"]')) {
        if (target.closest('dialog')) continue;
        for (const owner of target.querySelectorAll('product-form-component')) {
          if (owner.dataset.productId !== this.dataset.productId || owner.hasAttribute('data-v2-accessory-form')) continue;
          const form = owner.querySelector('form[action*="/cart/add"]');
          const button = form?.querySelector('.add-to-cart-button');
          if (form && button) return { target, form, button };
        }
      }
      return null;
    }

    // Buy strips mirror the main button: its label ("Sold out", "Pre-order") and disabled
    // state follow variant changes, so a gold ADD TO CART never offers an unbuyable variant.
    watchMain() {
      this.observer?.disconnect();
      // The final PDP renders no buy strip (Milen 2 Oct); only watch when a strip exists.
      if (!this.querySelector('[data-klp-buy-strip]')) return;
      const purchase = this.purchase();
      if (!purchase) return;
      this.mainButton = purchase.button;
      this.observer = new MutationObserver(() => this.syncStrips());
      this.observer.observe(purchase.button, { attributes: true, childList: true, subtree: true, characterData: true });
      this.syncStrips();
    }

    syncStrips() {
      const button = this.mainButton;
      if (!button) return;
      if (!button.isConnected) { this.watchMain(); return; }
      const text = button.querySelector('.add-to-cart-text__content');
      const value = (text ? text.textContent : button.textContent).trim();
      for (const link of this.querySelectorAll('[data-klp-buy-strip] .klp__btn')) {
        if (this.pending?.link === link || this.completed?.link === link) continue;
        const label = link.querySelector('[data-klp-label]');
        if (label && value && label.textContent !== value) label.textContent = value;
        // Stays a working link when sold out: it takes the shopper to the buy form (Notify me).
        link.classList.toggle('is-disabled', button.disabled);
      }
    }

    fixLinks() {
      const purchase = this.purchase();
      if (purchase) for (const link of this.querySelectorAll('.klp__btn[href^="#ProductInformation-"]')) {
        link.setAttribute('href', '#' + purchase.target.id);
      }
    }

    activate(event) {
      const link = event.target.closest('.klp__btn');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      this.fixLinks();
      const purchase = this.purchase();
      if (!purchase || purchase.button.disabled) return;
      event.preventDefault();
      // Engraving switched on but empty: the page scrolls to the input instead of adding.
      if (window.xzV2PdpEngravingGuard?.()) return;
      if (this.pending) return;
      this.restore();
      const label = link.querySelector('[data-klp-label]') || link;
      this.pending = { link, label, text: label.textContent, minWidth: link.style.minWidth,
        variantId: String(purchase.form.querySelector('[name="id"]')?.value || '') };
      link.style.minWidth = Math.ceil(link.getBoundingClientRect().width) + 'px';
      label.textContent = 'Adding…';
      link.classList.add('klp__btn--busy');
      link.setAttribute('aria-busy', 'true');
      this.pendingTimer = setTimeout(() => this.restore(), 8000);
      const container = purchase.button.closest('add-to-cart-component');
      const previous = container?.getAttribute('data-add-to-cart-animation');
      try {
        container?.setAttribute('data-add-to-cart-animation', 'false');
        purchase.button.click();
      } finally {
        if (container) {
          if (previous === null) container.removeAttribute('data-add-to-cart-animation');
          else container.setAttribute('data-add-to-cart-animation', previous);
        }
      }
    }

    complete() {
      clearTimeout(this.pendingTimer);
      this.completed = this.pending;
      this.pending = null;
      const { link, label } = this.completed;
      link.classList.remove('klp__btn--busy');
      link.classList.add('klp__btn--added');
      link.removeAttribute('aria-busy');
      label.textContent = 'Added';
      this.restoreTimer = setTimeout(() => this.restore(), 2000);
    }

    restore() {
      clearTimeout(this.pendingTimer);
      clearTimeout(this.restoreTimer);
      for (const state of [this.pending, this.completed]) if (state) {
        state.label.textContent = state.text;
        state.link.style.minWidth = state.minWidth;
        state.link.classList.remove('klp__btn--busy', 'klp__btn--added');
        state.link.removeAttribute('aria-busy');
      }
      this.pending = this.completed = null;
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.observer = null;
      this.restore();
    }
  }
  if (!customElements.get('knife-landing-actions')) customElements.define('knife-landing-actions', KnifeLandingActions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Mobile product card buttons and layout
  // Store pending operations to batch them
  const pendingCardUpdates = [];
  let isProcessingCards = false;
  
  function initMobileProductButtons() {
    if (window.innerWidth >= 750) return;
    
    const productCards = document.querySelectorAll('.product-grid__item');
    
    productCards.forEach(card => {
      // Skip if already processed
      if (card.dataset.mobileProcessed === 'true') return;
      card.dataset.mobileProcessed = 'true';
      
      const content = card.querySelector('.product-card__content');
      if (!content) return;
      
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      
      const productUrl = productLink.getAttribute('href');
      const variantMatch = productUrl.match(/variant=(\d+)/);
      const variantId = variantMatch ? variantMatch[1] : null;
      
      // Find the title link and price elements
      const titleLink = content.querySelector('a.contents.user-select-text');
      const priceEl = content.querySelector('product-price.text-block');
      
      // Queue this card for processing
      pendingCardUpdates.push({ card, content, titleLink, priceEl, productUrl, variantId });
    });
    
    // Process all cards in a single batch
    if (pendingCardUpdates.length > 0 && !isProcessingCards) {
      isProcessingCards = true;
      requestAnimationFrame(() => {
        processPendingCards();
        isProcessingCards = false;
      });
    }
  }
  
  function processPendingCards() {
    // Use DocumentFragment to batch DOM operations
    pendingCardUpdates.forEach(({ card, content, titleLink, priceEl, productUrl, variantId }) => {
      // Skip if already has button row (double-check)
      if (card.querySelector('.mobile-btn-row')) return;
      
      // Create info row wrapper for title + price (only if both exist)
      if (titleLink && priceEl && !content.querySelector('.mobile-info-row')) {
        const infoRow = document.createElement('div');
        infoRow.className = 'mobile-info-row';
        
        // Insert before titleLink, then move title and price into it
        titleLink.parentNode.insertBefore(infoRow, titleLink);
        infoRow.appendChild(titleLink);
        infoRow.appendChild(priceEl);
      }
      
      // Create button row
      const btnRow = document.createElement('div');
      btnRow.className = 'mobile-btn-row';
      
      // View Details button (secondary/subtle)
      const viewBtn = document.createElement('a');
      viewBtn.href = productUrl;
      viewBtn.className = 'mobile-btn mobile-btn--secondary';
      viewBtn.textContent = 'SHOP NOW';
      viewBtn.addEventListener('click', (e) => e.stopPropagation());
      
      // Add to Cart button (primary/red)
      const cartBtn = document.createElement('button');
      cartBtn.type = 'button';
      cartBtn.className = 'mobile-btn mobile-btn--primary';
      cartBtn.textContent = 'Add to Cart';
      cartBtn.dataset.variantId = variantId;
      
      cartBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (!variantId) {
          window.location.href = productUrl;
          return;
        }
        
        cartBtn.textContent = 'Adding...';
        cartBtn.disabled = true;
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
          });
          
          if (response.ok) {
            cartBtn.textContent = 'Added ✓';
            
            // Fetch updated cart to get total item count
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            
            // Dispatch cart:update event (theme's expected event)
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                data: {
                  itemCount: cart.item_count,
                  source: 'mobile-add-to-cart'
                }
              }
            }));
            
            setTimeout(() => {
              cartBtn.textContent = 'Add to Cart';
              cartBtn.disabled = false;
            }, 2000);
          } else {
            throw new Error('Failed to add');
          }
        } catch (err) {
          cartBtn.textContent = 'View Options';
          cartBtn.addEventListener('click', () => window.location.href = productUrl, { once: true });
        }
      });
      
      btnRow.appendChild(viewBtn);
      btnRow.appendChild(cartBtn);
      
      // Insert button row at the end of content
      content.appendChild(btnRow);
    });
    
    // Clear the queue
    pendingCardUpdates.length = 0;
  }
  
  // Initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileProductButtons, { once: true });
  } else {
    // Run immediately but in next frame to not block rendering
    requestAnimationFrame(initMobileProductButtons);
  }
  
  // Re-run for infinite scroll (debounced)
  let scrollTimeout = null;
  const observer = new MutationObserver((mutations) => {
    let hasNewProducts = false;
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) hasNewProducts = true;
    });
    
    if (hasNewProducts) {
      // Debounce to batch multiple additions
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(initMobileProductButtons, 50);
    }
  });
  
  // Set up observer
  const setupObserver = () => {
    const grid = document.querySelector('.product-grid');
    if (grid) {
      observer.observe(grid, { childList: true, subtree: true });
    }
  };
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver, { once: true });
  } else {
    setupObserver();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  (function () {
    // Section javascript blocks are bundled into ONE global file that loads on every
    // page, so everything here is a no-op unless the search wrapper is present.
    function init() {
      var wrapper = document.getElementById('search-load-more-wrapper');
      if (!wrapper) return;

      var btn = document.getElementById('search-load-more');
      var grid = document.querySelector('.search-results-list .product-grid[ref="grid"]');
      if (!btn || !grid) return;

      var current = parseInt(wrapper.dataset.currentPage, 10) || 1;
      var total = parseInt(wrapper.dataset.totalPages, 10) || 1;
      var sectionId = wrapper.dataset.sectionId;
      var loading = false;

      btn.addEventListener('click', function () {
        if (loading || current >= total) return;
        loading = true;
        btn.disabled = true;
        btn.textContent = 'Loading...';

        // Rebuild from the CURRENT url so q, type and any active facet survive paging.
        var url = new URL(window.location.href);
        url.searchParams.set('page', String(current + 1));
        url.searchParams.set('section_id', sectionId);

        fetch(url.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var incoming = doc.querySelectorAll('.product-grid[ref="grid"] > [ref="cards[]"]');

            // Dedupe by product id. Shopify can repeat a product across page
            // boundaries when the underlying result order shifts mid-session.
            var seen = {};
            grid.querySelectorAll('.product-grid__item').forEach(function (el) {
              var id = el.getAttribute('data-product-id');
              if (id) seen[id] = true;
            });

            var fragment = document.createDocumentFragment();
            var added = 0;
            incoming.forEach(function (el) {
              var id = el.getAttribute('data-product-id');
              if (id && seen[id]) return;
              if (id) seen[id] = true;
              fragment.appendChild(el);
              added++;
            });
            if (added > 0) grid.appendChild(fragment);

            current += 1;
            wrapper.dataset.currentPage = String(current);

            // Deliberately NOT rewriting the address bar. The collection button does,
            // which leaves ?page=3 behind — refreshing then shows page 3 ALONE and the
            // first two pages appear lost. Leaving the url untouched means a refresh
            // simply returns to the first page, which is the less surprising of the two.

            if (current >= total) {
              wrapper.style.display = 'none';
            } else {
              btn.disabled = false;
              btn.textContent = 'Load More Products';
            }
            loading = false;
          })
          .catch(function () {
            // Leave the button usable so a transient failure can be retried.
            btn.disabled = false;
            btn.textContent = 'Load More Products';
            loading = false;
          });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
